interface TypographyProps {
    variant: 'header' | 'title' | 'subtitle' | 'label' | 'paragraph'
    children: React.ReactNode
    leftIcon?: React.ReactNode
    rightIcon?: React.ReactNode
    customCSS?: string
}


const Typography: React.FC<TypographyProps> = ({
    variant,
    children,
    leftIcon,
    rightIcon,
    customCSS
}) => {

    if(variant === 'header') {
        return (
            <h1 className={`text-2xl font-bold text-gray-800 ${customCSS} dark:text-white`}>
                {leftIcon && <span className="mr-2">{leftIcon}</span>}
                {children}
                {rightIcon && <span className="ml-2">{rightIcon}</span>}
            </h1>
        )
    }

    if(variant === 'title') {
        return (
            <h2 className={`text-xl font-medium text-gray-800 ${customCSS} dark:text-white`}>
                {leftIcon && <span className="mr-2">{leftIcon}</span>}
                {children}
                {rightIcon && <span className="ml-2">{rightIcon}</span>}
            </h2>
        )
    }

    if(variant === 'subtitle') {
        return (
            <h3 className={`text-lg font-medium text-gray-600 ${customCSS} dark:text-white`}>
                {leftIcon && <span className="mr-2">{leftIcon}</span>}
                {children}
                {rightIcon && <span className="ml-2">{rightIcon}</span>}
            </h3>
        )
    }

    if(variant === 'label') {
        return (
            <p className={`text-sm font-medium text-gray-500 ${customCSS} dark:text-white`}>
                {leftIcon && <span className="mr-2">{leftIcon}</span>}
                {children}
                {rightIcon && <span className="ml-2">{rightIcon}</span>}
            </p>
        )
    }

    if(variant == 'paragraph') {
        return (
            <p className={`${customCSS || 'text-sm'} text-gray-600 dark:text-white`}>
                {children}
            </p>
        )
    }
}

export default Typography